import { Col, Row } from "react-bootstrap";
import ToolTips from "utils/toolTips";
import { formatPercent } from "utils/formatNumber";
import { adTypesByChannel } from "./AdTypeSection";
import getMetricSpec from "views/merchandise/metrics";
import { useAppSelector } from "redux/hooks";
import { getTrendColor } from "components/custom/summaryReport/utils";

const Card = ({ name, title, selected, setSelected, data, toolTip, cardMetrics }) => {
  const marketPlace = useAppSelector((state) => state.marketPlace);

  return (
    <div
      className="me-4 p-4 mb-3"
      style={{
        height: "150px",
        cursor: "pointer",
        boxShadow: "none",
        border: `2px solid ${selected?.value === data?.ad_type ? "rgb(15,195,152, 0.50)" : "rgb(238, 238, 238)"}`,
        borderRadius: "25px",
        backgroundColor: selected?.value === data?.ad_type ? "rgb(15,195,152, 0.15)" : null,
      }}
      onClick={() =>
        selected?.value === data?.ad_type ?
          setSelected({ label: "All Media Plan Types", value: "all" })
        : setSelected({ label: name, value: data?.ad_type })
      }
    >
      <Row className="ps-4">
        <Col xs={12} className="pb-1">
          <span className="fs-4 fw-bold">
            {title}
            {toolTip && <ToolTips toolTip={toolTip} position={"top"} id={name + "tooltip"} />}
          </span>
        </Col>
      </Row>
      <Row className="d-flex h-100 align-items-center">
        {cardMetrics.map((metric) => {
          const { title, valueAccessor, prevValueAccessor, overrideValue, overridePrevValue } = metric;

          const metricSpec = getMetricSpec(marketPlace.marketPlace, valueAccessor);

          const value =
            overrideValue ? overrideValue
            : valueAccessor ? metricSpec.formatter(data[valueAccessor])
            : null;
          const prevValue =
            overridePrevValue ? overridePrevValue
            : prevValueAccessor ? data[prevValueAccessor]
            : null;

          return (
            <Col key={`${metricSpec.id}-${metricSpec.name}`} className="fs-5 text-center align-items-flex-start">
              <span style={{ whiteSpace: "nowrap" }}>{title}</span>
              <span className="fs-3 fw-bold d-block">{value}</span>
              {prevValue ?
                <span
                  style={{
                    color: getTrendColor(prevValue, prevValueAccessor, "rgb(15, 195, 152)", "rgb(240, 60, 103)"),
                  }}
                  className="fw-bold"
                >
                  {formatPercent(prevValue, 1, true)}
                </span>
              : <br />}
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

const AdTypeCards = ({ selectedCard, setSelectedCard, data }) => {
  const channel = useAppSelector((state) => state.channel);

  const cardStats = [
    {
      title: "# of Active Plans",
      valueAccessor: "active_ad_count",
    },
    {
      title: "Ad Sales",
      valueAccessor: "ad_sales",
      prevValueAccessor: "ad_sales_percent",
    },
    {
      title: "Ad Spend",
      valueAccessor: "cost",
      prevValueAccessor: "cost_percent",
    },
    {
      title: "ACOS",
      valueAccessor: "acos",
      prevValueAccessor: "acos_delta",
    },
    {
      title: "CTR",
      valueAccessor: "ctr",
      prevValueAccessor: "ctr_delta",
    },
    {
      title: "Clicks",
      valueAccessor: "clicks",
      prevValueAccessor: "clicks_percent",
    },
    {
      title: "Impressions",
      valueAccessor: "impressions",
      prevValueAccessor: "impressions_percent",
    },
  ];

  return (
    <>
      {adTypesByChannel[channel.currentChannel ?? "amazon"]
        ?.map((type) => {
          const adTypeData = data?.find((row) => row.ad_type === type.value) ?? [];
          return { ...type, adTypeData };
        })
        ?.sort((a, b) => {
          if (!b.adTypeData?.ad_sales) {
            return -1;
          }
          return b.adTypeData?.ad_sales - a.adTypeData?.ad_sales;
        })
        ?.filter((type) => {
          return type?.adTypeData?.ad_sales || type?.adTypeData?.cost;
        })
        ?.map((type) => (
          <Card
            key={`${channel.currentChannel}-${type.value}`}
            title={type.label}
            name={type.label}
            selected={selectedCard}
            setSelected={setSelectedCard}
            data={type.adTypeData ?? []}
            cardMetrics={cardStats}
          />
        ))}
    </>
  );
};

export default AdTypeCards;
